import { createClient } from '@supabase/supabase-js';

// Same client is used for the DB and Edge Functions (`supabase.functions.invoke`).
// Functions are reached at `${REACT_APP_SUPABASE_URL}/functions/v1/<function-name>`.
const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

/** For admin UI: show why the client is missing (env is baked in at `npm start`). */
export function getSupabaseEnvDebugInfo() {
  return {
    hasUrl: Boolean(supabaseUrl),
    hasKey: Boolean(supabaseAnonKey),
    url: supabaseUrl,
    anonKeyLength: supabaseAnonKey.length,
  };
}
